module.exports = __webpack_public_path__ + "static/media/settly.a5d91a0d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/settly.webp
// module id = 254
// module chunks = 0